import api from '@/apis'
// import Vuetify from '@/plugins/vuetify'
export default {
  state: {
    type: null,
    visibility: false,
    filtered_flow: [],
    device_id: '',
    category_id: '',
    intent_name: null,
    search: '',
    column: {
      loading: false,
      topic_layers: []
    },
    diagram: {
      loading: false,
      flow: {}
    },
    selected_layers: []
  },
  mutations: {
    // Init and reset Dialog
    INIT_MANAGE_CATEGORY_DIALOG(state, payload) {
      const { device_id, category_id, search, type, specific } = payload
      state.device_id = device_id || null
      state.type = type || null
      state.category_id = category_id || null
      state.search = search || null
      state.specific = specific || null

      state.visibility = true
    },
    RESET_MANAGE_CATEGORY_DIALOG(state) {
      state.visibility = false

      state.device_id = null
      state.category_id = null
      state.type = null
      state.column = { loading: false, topic_layers: [] }
      state.diagram = { loading: false, flow: {} }
      state.specific = false
      state.selected_layers = []
    },
    SET_MANAGE_CATEGORY_SELECTED_LAYERS(state) {
      state.selected_layers = []
    },
    SET_MANAGE_CATEGORY_FILTERED_FLOW(state, payload) {
      if (payload && Object.keys(payload).length) {
        const filtered_flow = []
        const flow_id_list = Object.keys(payload)
        flow_id_list.forEach((flow_id) => {
          filtered_flow.push(payload[flow_id])
        })
        state.filtered_flow = filtered_flow
      } else state.filtered_flow = []
    },
    // Dialog actions event
    SET_MANAGE_CATEGORY_COLUMN_LOADING(state, payload) {
      state.column.loading = payload
    },
    SET_MANAGE_CATEGORY_COLUMN_INTENT_NAME(state, payload) {
      state.column.intent_name = payload
    },
    SET_MANAGE_CATEGORY_COLUMN_TOPIC_LAYERS(state, payload) {
      state.column.topic_layers = payload
    },
    APPEND_MANAGE_CATEGORY_COLUMN_TOPIC_LAYERS(state, payload) {
      state.column.topic_layers.push(payload)
    },
    PREPEND_MANAGE_CATEGORY_COLUMN_TOPIC_LAYERS(state, payload) {
      state.column.topic_layers.unshift(payload)
    },
    ADD_CATEGORY_COLUMN_TOPIC_LAYER(state, payload) {
      const { index, category_id, category_name } = payload
      state.column.topic_layers[index].data.push({ category_name: category_name, category_id: category_id })
    },
    UPDATE_CATEGORY_COLUMN_TOPIC_LAYER(state, payload) {
      const { index, topic_index, category_name } = payload
      state.column.topic_layers[index].data[topic_index].category_name = category_name
    },
    DELETE_CATEGORY_COLUMN_TOPIC_LAYER(state, payload) {
      const { index, topic_index, parent_id, category_id } = payload
      state.column.topic_layers[index].data.splice(topic_index, 1)
      if (!state.column.topic_layers[index].data.length) {
        const parent_index = state.column.topic_layers[index - 1].data.findIndex((item) => item.category_id === parent_id)
        state.column.topic_layers[index - 1].data[parent_index].has_child = false
      }
      if (state.column.topic_layers[index + 1] && state.column.topic_layers[index + 1].parent_id === category_id) {
        state.column.topic_layers.splice(index + 1, state.column.topic_layers.length - index)
      }
    },

    SET_CATEGORY_COLUMN_TOPIC_LAYER_HAS_CHILD(state, payload) {
      const { index, category_id, has_child } = payload
      if (index >= 0) {
        const parent_index = state.column.topic_layers[index].data.findIndex((item) => item.category_id === category_id)
        state.column.topic_layers[index].data[parent_index].has_child = has_child
      }
    },
    SET_MANAGE_CATEGORY_DIAGRAM_LOADING(state, payload) {
      state.diagram.loading = payload
    },
    SET_MANAGE_CATEGORY_DIAGRAM_FLOW(state, payload) {
      state.diagram.flow = payload
    }
  },
  actions: {
    async initManageCategoryDialog({ commit, dispatch }, payload) {
      if (!payload.specific) {
        await dispatch('fetchManageCategoryLayer', { device_id: payload.device_id })
      } else await dispatch('fetchSpecificCategory', { category_id: payload.category_id })
      await commit('INIT_MANAGE_CATEGORY_DIALOG', payload)
    },

    async fetchManageCategoryLayer({ commit }, payload) {
      try {
        commit('SET_MANAGE_CATEGORY_COLUMN_LOADING', true)
        const response = await api.getCategoryColumn({ device_id: payload.device_id, category_id: payload.category_id || null })
        if (response.data.success) {
          if (payload.prepend) await commit('PREPEND_MANAGE_CATEGORY_COLUMN_TOPIC_LAYERS', { data: response.data.data, parent_id: payload.category_id || null })
          else await commit('APPEND_MANAGE_CATEGORY_COLUMN_TOPIC_LAYERS', { data: response.data.data, parent_id: payload.category_id || null })
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_CATEGORY_COLUMN_LOADING', false)
      }
    },

    async fetchSpecificCategory({ state, commit, rootState, dispatch }, payload) {
      try {
        const device_id = rootState.auth.selected_device
        const response = await api.getCategoryTree({ device_id: device_id, category_id: payload.category_id || null })
        state.selected_layers.unshift(payload.category_id)
        if (!payload.category_id) {
          dispatch('fetchManageCategoryLayer', { prepend: true })
        } else {
          if (response.data.data.categories[payload.category_id].parent_id) {
            dispatch('fetchManageCategoryLayer', { category_id: response.data.data.categories[payload.category_id].parent_id, prepend: true })
            dispatch('fetchSpecificCategory', { category_id: response.data.data.categories[payload.category_id].parent_id })
          } else {
            dispatch('fetchManageCategoryLayer', { category_id: response.data.data.categories[payload.category_id].parent_id, prepend: true })
          }
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async fetchManageCategory({ commit, rootState }) {
      try {
        const device_id = rootState.auth.selected_device

        commit('SET_MANAGE_CATEGORY_DIAGRAM_LOADING', true)
        commit('SET_MANAGE_CATEGORY_FILTERED_FLOW', {})
        const response = await api.getCategoryTree({ ...device_id })
        if (response.data.success) {
          commit('SET_MANAGE_CATEGORY_DIAGRAM_FLOW', response.data.data.categories)
          commit('SET_MANAGE_CATEGORY_FILTERED_FLOW', response.data.data.categories)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_CATEGORY_DIAGRAM_LOADING', false)
      }
    }
  }
}
